import { AlertDialog, DialogContainer, Link, View } from '@adobe/react-spectrum';
import React, { useState } from 'react';

import { commonApi, handleApiCall } from '@exchange-frontends/api';
import { useHandleApiCall } from '@exchange-frontends/custom-hooks';

import HelpSupportGridListItem from './HelpSupportGridListItem';

const getInstructionTemplatesHandler = handleApiCall(commonApi.getInstructionTemplates);

const InstallationOrDocumentation = ({ label, icon, details, loading, type }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  //In EC for standard install instructions we need to get the URL value from instruction templates
  const { response: instructionTemplates, loading: instructionTemplatesLoading } = useHandleApiCall({
    shouldFetch: Boolean(type === 'ec' && details?.some((detail) => detail?.type === 'installInstructions')),
    handler: getInstructionTemplatesHandler,
    shouldShowError: false,
  });

  return (
    <>
      <HelpSupportGridListItem
        icon={icon}
        label={label}
        loading={loading}
        extraLoadings={instructionTemplatesLoading}
        dataLaunchId={`Help and Support : ${label}`}
        onClick={() => setIsDialogOpen(true)}
      />
      <DialogContainer onDismiss={() => setIsDialogOpen(false)}>
        {!loading && !instructionTemplatesLoading && isDialogOpen && (
          <AlertDialog title={label} variant="information" primaryActionLabel="Close">
            {details?.map((detail) => {
              if (instructionTemplates) {
                detail.url = instructionTemplates.find((template) => template.name === detail.name)?.url ?? detail?.url;
              }
              return (
                <React.Fragment key={detail?.name}>
                  <View marginBottom="size-65">
                    <Link isQuiet>
                      <a
                        href={detail.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`Help and Support Url: ${label}`}
                        data-launchid={`Help and Support Url: ${label}`}
                      >
                        {detail.name ?? detail?.url}
                      </a>
                    </Link>
                    <br />
                  </View>
                </React.Fragment>
              );
            })}
          </AlertDialog>
        )}
      </DialogContainer>
    </>
  );
};

export default InstallationOrDocumentation;
